// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AddToList: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
            <path
                fill="currentColor"
                d="M1.875,0 L0.375,0 C0.167718887,0 0,0.167812586 0,0.375 L0,1.875 C0,2.08228111 0.167718887,2.25 0.375,2.25 L1.875,2.25 C2.08218741,2.25 2.25,2.08124971 2.25,1.875 L2.25,0.375 C2.25,0.167812586 2.08218741,0 1.875,0 Z M1.875,3.75 L0.375,3.75 C0.167718887,3.75 0,3.91874993 0,4.125 L0,5.625 C0,5.83228111 0.167718887,6 0.375,6 L1.875,6 C2.08218741,6 2.25,5.83124971 2.25,5.625 L2.25,4.125 C2.25,3.91874993 2.08218741,3.75 1.875,3.75 Z M1.875,7.5 L0.375,7.5 C0.167718887,7.5 0,7.66875029 0,7.875 L0,9.375 C0,9.58228111 0.167718887,9.75 0.375,9.75 L1.875,9.75 C2.08218741,9.75 2.25,9.58124971 2.25,9.375 L2.25,7.875 C2.25,7.66875029 2.08218741,7.5 1.875,7.5 Z M4.5,1.875 L11.25,1.875 C11.6641409,1.875 12,1.53914022 12,1.14609361 C12,0.753046989 11.664844,0.375 11.25,0.375 L4.5,0.375 C4.08515632,0.375 3.75,0.710859776 3.75,1.10390639 C3.75,1.49695301 4.08515632,1.875 4.5,1.875 Z M11.25,7.875 L4.5,7.875 C4.08585942,7.875 3.75,8.21085906 3.75,8.625 C3.75,9.03914094 4.08585942,9.375 4.5,9.375 L11.25,9.375 C11.6641409,9.375 12,9.03914094 12,8.625 C12,8.21085906 11.664844,7.875 11.25,7.875 Z M11.25,4.125 L4.5,4.125 C4.08515632,4.125 3.75,4.46015632 3.75,4.875 C3.75,5.28984404 4.08585942,5.625 4.5,5.625 L11.25,5.625 C11.6641409,5.625 12,5.28914094 12,4.875 C12,4.46085906 11.664844,4.125 11.25,4.125 Z"
                transform="translate(0 .625)"
            />
        </svg>
    );
};

export default React.memo(AddToList);
